import React, { Fragment, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";
import {  userActions,authActions } from "../../../_store";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((x) => x.auth.user);

  const [toggle, setToggle] = useState("");
  const onClick = (name) =>
    {
      setToggle(toggle === name ? "" : name);
      if(!toggle)
      {
        
        dispatch(userActions.getMessageUserList({UserID: currentUser.Id})).then((response) => {
          
          if (response?.type === 'users/getMessageUserList/fulfilled') {
            
            let userDetail={...currentUser};
            userDetail.NotificationCount=response?.payload?.Item2;
              dispatch(authActions.updateLocalStorage(userDetail));
          }
      });
      }
    }

  return (
    <Fragment>
      <NavHader />
      <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
